/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuDisplayPrefsSelect_user$ref: FragmentReference;
export type SbSharedRefineMenuDisplayPrefsSelect_user = {|
  +isVerifiedTrade: ?boolean,
  +$refType: SbSharedRefineMenuDisplayPrefsSelect_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'dbe4e541582a5514bad9681d998d2c33';
module.exports = node;
